import { render, staticRenderFns } from "./selectCity.vue?vue&type=template&id=2be206da&scoped=true&"
import script from "./selectCity.vue?vue&type=script&lang=js&"
export * from "./selectCity.vue?vue&type=script&lang=js&"
import style0 from "./selectCity.vue?vue&type=style&index=0&id=2be206da&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be206da",
  null
  
)

export default component.exports